import React from 'react';
import { FiEdit2 } from 'react-icons/fi';

import css from './Sections.module.css';
import { H3, Icons, NamedLink } from '../../../components';
import classNames from 'classnames';
import { findCharterCompanyOption, useBoatCatalog } from '../../../util/boatCatalog';

const SectionMyVessel = props => {
  const { publicData, intl, editable = false } = props;
  const boatDetails = publicData?.boatDetails;
  const { charterCompanies } = useBoatCatalog();

  const charterCompany = findCharterCompanyOption(charterCompanies, boatDetails?.charterCompany);
  const boatImageUrl = boatDetails?.brandLogo || charterCompany?.logoUrl || null;
  const hasBoatDetails = !!(boatDetails?.boatName || boatDetails?.type || boatImageUrl);
  const editLabel = intl.formatMessage({ id: 'ProfilePage.SectionMyVessel.editBoat' });

  return (
    <div className={css.myVesselSection}>
      <div className={css.myVesselTitle}>
        <H3 className={css.captainsLogTitle}>
          <Icons name="anchor" />
          {intl.formatMessage({ id: 'ProfilePage.SectionMyVessel.heading' })}
        </H3>
        <span className={css.visibility}>
          <span className={css.lockIcon}>🔒</span>
          {intl.formatMessage({ id: 'ProfilePage.SectionMyVessel.visibility' })}
        </span>
      </div>
      <div className={classNames(css.coverPhoto, css.myVesselCoverPhoto)}>
        {boatImageUrl ? (
          <img className={css.myCoverPhoto} src={boatImageUrl} alt="" />
        ) : (
          <div className={css.myCoverPhotoThumb}>
            <Icons name="image" />
            <span>{intl.formatMessage({ id: 'ProfilePage.SectionMyVessel.noBoatImage' })}</span>
          </div>
        )}
      </div>
      {hasBoatDetails ? (
        <div className={css.vesselUserInfo}>
          {boatDetails?.boatName ? (
            <h4 className={css.vesselName}>{boatDetails.boatName}</h4>
          ) : null}
          {boatDetails?.type ? <p className={css.vesselType}>{boatDetails.type}</p> : null}
        </div>
      ) : (
        <p className={css.emptyState}>
          {intl.formatMessage({ id: 'ProfilePage.SectionMyVessel.noBoat' })}
        </p>
      )}
      {editable ? (
        <NamedLink
          className={classNames(css.myBoatEditLink, css.editIconActionButton)}
          name="MyBoatPage"
          title={editLabel}
        >
          <FiEdit2 aria-hidden="true" focusable="false" />
          <span className={css.visuallyHidden}>{editLabel}</span>
        </NamedLink>
      ) : null}
    </div>
  );
};

export default SectionMyVessel;
